
import { useEffect, useRef } from 'react';

interface AdSenseAdProps {
  adSlot: string;
  adFormat?: string;
  responsive?: boolean;
  className?: string;
}

const AdSenseAd = ({ 
  adSlot, 
  adFormat = "auto", 
  responsive = true, 
  className = "w-full" 
}: AdSenseAdProps) => {
  const adRef = useRef<HTMLDivElement>(null);
  const hasInitialized = useRef(false);

  useEffect(() => {
    const initializeAd = () => {
      try {
        console.log('AdSense - Initializing ad with slot:', adSlot);
        
        // Check if adsbygoogle is available
        if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
          console.log('AdSense - adsbygoogle is available');
          
          // Only push if not already initialized
          if (!hasInitialized.current && adRef.current) {
            console.log('AdSense - Pushing ad to queue');
            ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
            hasInitialized.current = true;
          }
        } else {
          console.log('AdSense - adsbygoogle not yet available, retrying...');
          // Retry after a short delay
          setTimeout(initializeAd, 1000);
        }
      } catch (error) {
        console.error('AdSense error for slot', adSlot, ':', error);
      }
    };

    // Wait a bit for the script to load, then initialize
    const timer = setTimeout(initializeAd, 500);
    
    return () => {
      clearTimeout(timer);
    };
  }, [adSlot]);

  return (
    <div className={className} ref={adRef} style={{ position: 'relative', isolation: 'isolate' }}>
      <ins
        className="adsbygoogle"
        style={{ 
          display: 'block',
          minHeight: '100px',
          backgroundColor: '#f5f5f5',
          border: '1px dashed #ccc',
          textAlign: 'center',
          lineHeight: '100px',
          color: '#999',
          position: 'relative',
          zIndex: 1
        }}
        data-ad-client="ca-pub-7610908742964821"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={responsive.toString()}
      />
      {/* Fallback content while ads load - positioned within container */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        color: '#999',
        pointerEvents: 'none',
        zIndex: 0
      }}>
        Cargando anuncio...
      </div>
    </div>
  );
};

export default AdSenseAd;
